import DIApi from './_diApi';

class JusticeDecisionAPI extends DIApi {
  controllerName = 'JusticeDecisions';
}

export default new JusticeDecisionAPI();
